import { Alert, Button, Col, Form, Input, Layout, Row, Space, Typography } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Fade } from 'react-reveal';
import { Link } from 'react-router-dom';
import React from 'react';
import SimileLogo from '../../assets/images/simile-logo.svg';
import { useLogin } from './useLogin';
import { withRouter } from 'react-router';

const Login: React.FC = () => {
	const { Content } = Layout;
	const { Text } = Typography;
	const {
		error,
		loadingButton,
		onFinish,
	} = useLogin();

	return (
		<Layout style={{ height: '100vh' }}>
			<Content
				style={{
					padding: '0 50px',
					marginTop: 40,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '100vh',
				}}
			>
				<div
					style={{
						background: '#fff',
						padding: 24,
						height: 450,
						width: 400,
						textAlign: 'center',
						flexDirection: 'column',
						justifyContent: 'center',
						display: 'flex',
					}}
				>
					<Fade>
						<Row justify="center" style={{marginBottom: '20px'}}>
							<Col style={{textAlign: 'center'}}>
								<Space direction="vertical">
									<Text>Simile Analyst Tool</Text>
									<img srcSet={SimileLogo} className="logo-main" alt="Logo" />
								</Space>
							</Col>
						</Row>

						{error && <Alert message={error} type="error" showIcon closable/> }

						<Form className="login-form"
							initialValues={{ remember: false }}
							onFinish={onFinish}
							onFinishFailed={(errorInfo): void => console.log('Failed:', errorInfo)}
							layout="vertical"
						>
							<Form.Item
								name="email"
								label="Email"
								rules={[{ required: true }]}
							>
								<Input
									prefix={
										<UserOutlined
											style={{ color: 'rgba(0,0,0,.25)' }}
										/>
									}
									placeholder="Email"
								/>
							</Form.Item>
							<Form.Item
								name="password"
								label="Password"
								rules={[{ required: true }]}
							>
								<Input
									prefix={
										<LockOutlined
											style={{ color: 'rgba(0,0,0,.25)' }}
										/>
									}
									type="password"
									placeholder="Password"
								/>
							</Form.Item>
							<Form.Item>
								<Link to="/recover">Forgot Your Password?‎</Link>
							</Form.Item>
							<Form.Item>
								<Button
									loading={loadingButton}
									type="primary"
									htmlType="submit"
									className="login-form-button"
									style={{ marginRight: 10 }}
								>
									Login
								</Button>
							</Form.Item>
						</Form>
					</Fade>
				</div>
			</Content>
		</Layout>
	);
};

export default withRouter(Login);
